import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path:'*',
        redirect:'/home' //重定向
    },
    {
        path:'/login',
        name:'login',
        component:()=>import('@/components/LoginCom.vue')
    },
    {
        path:'/home',
        name:'home',
        component:()=>import('@/components/HomeCom.vue'),
        
    },
	{
	    path:'/feixian',
	    name:'feixian',
	    component:()=>import('@/components/feixian.vue'),
	    
	},
    
]
const router = new VueRouter({
    mode:'history',
    routes
})

export default router
